// Ajustes del análisis: clases activas, confianza mínima por clase y horario de obra.
// Se aplica al instante sobre los datos ya cargados (no reprocesa ni recarga la página).
import React, { useState } from 'react';
import { FAMILIES, classInfo, DEFAULT_CFG } from './iaData';
import { T, Btn, inputStyle } from './ui';

export default function SensitivityModal({ cfg, onApply, onClose, internal }) {
  const [c, setC] = useState(cfg);
  const toggle = (cls) => setC({ ...c, enabled: c.enabled.includes(cls) ? c.enabled.filter((x) => x !== cls) : [...c.enabled, cls] });
  const setThr = (cls, v) => setC({ ...c, thr: { ...c.thr, [cls]: v } });

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(17,24,39,.45)', zIndex: 1000, display: 'grid', placeItems: 'center', padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: T.card, color: T.text, border: `1px solid ${T.line}`, borderRadius: 20, boxShadow: '0 25px 50px rgba(0,0,0,.25)', width: 'min(860px, 100%)', maxHeight: '90vh', overflowY: 'auto', padding: 20 }}>
        <h3 style={{ margin: 0, fontSize: 18 }}>Ajustes</h3>
        <p style={{ color: T.muted, fontSize: 13, margin: '6px 0 16px', lineHeight: 1.5 }}>
          Elegí qué querés ver en el panel y la jornada de la obra. Se aplica al instante.
          {internal && <> <b style={{ color: T.text }}>(Interno)</b> La confianza mínima descarta detecciones dudosas del modelo.</>}
        </p>
        {FAMILIES.map((f) => (
          <div key={f.key} style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.6, color: T.muted, marginBottom: 6 }}>{f.label}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 8 }}>
              {f.classes.map((cls) => {
                const on = c.enabled.includes(cls), col = classInfo(cls).color, v = c.thr[cls] ?? 0;
                return (
                  <div key={cls} style={{ background: T.card2, border: `1px solid ${T.line}`, borderRadius: 10, padding: '8px 10px', opacity: on ? 1 : 0.5 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                      <span style={{ color: col, fontWeight: 700, fontSize: 13 }}>{classInfo(cls).label}</span>
                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, color: T.muted, cursor: 'pointer' }}>
                        <input type="checkbox" checked={on} onChange={() => toggle(cls)} style={{ accentColor: col }} /> {on ? 'activa' : 'apagada'}
                      </label>
                    </div>
                    {internal && <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                      <input type="range" min={0} max={0.9} step={0.05} value={v} disabled={!on} onChange={(e) => setThr(cls, +e.target.value)} style={{ flex: 1, accentColor: col }} />
                      <span style={{ width: 52, textAlign: 'right', fontSize: 12, fontVariantNumeric: 'tabular-nums' }}>≥ {v.toFixed(2)}</span>
                    </div>}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', padding: '12px 0', borderTop: `1px solid ${T.line}`, fontSize: 13 }}>
          <label style={{ display: 'inline-flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
            <input type="checkbox" checked={c.onlyWork} onChange={(e) => setC({ ...c, onlyWork: e.target.checked })} /> Solo horario de obra
          </label>
          <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', color: T.muted }}>
            de <input type="number" min={0} max={23} value={c.workFrom} onChange={(e) => setC({ ...c, workFrom: +e.target.value })} style={{ ...inputStyle, width: 56 }} />
            a <input type="number" min={1} max={24} value={c.workTo} onChange={(e) => setC({ ...c, workTo: +e.target.value })} style={{ ...inputStyle, width: 56 }} /> h
          </span>
          <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', color: T.muted }} title="Se usa para medir si la obra arranca tarde o corta antes">
            Jornada pactada <input type="time" value={toHM(c.jIni ?? 480)} onChange={(e) => setC({ ...c, jIni: fromHM(e.target.value) })} style={inputStyle} />
            a <input type="time" value={toHM(c.jFin ?? 1020)} onChange={(e) => setC({ ...c, jFin: fromHM(e.target.value) })} style={inputStyle} />
          </span>
          <label style={{ display: 'inline-flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
            <input type="checkbox" checked={c.blurPeople} onChange={(e) => setC({ ...c, blurPeople: e.target.checked })} /> Difuminar personas en los recortes
          </label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
          <Btn onClick={onClose}>Cancelar</Btn>
          <Btn onClick={() => setC(DEFAULT_CFG)}>Restablecer</Btn>
          <Btn active onClick={() => { onApply(c); onClose(); }}>Aplicar</Btn>
        </div>
      </div>
    </div>
  );
}

const toHM = (m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
const fromHM = (v) => { const [h, m] = String(v || '08:00').split(':').map(Number); return h * 60 + (m || 0); };
